var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1667 4H20.5C19.7636 4 19.1667 4.59695 19.1667 5.33333V12C19.1667 12.7364 19.7636 13.3333 20.5 13.3333H27.1667C27.903 13.3333 28.5 12.7364 28.5 12V5.33333C28.5 4.59695 27.903 4 27.1667 4Z",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 28V10.6667C13.8333 10.313 13.6929 9.9739 13.4428 9.72385C13.1928 9.4738 12.8536 9.33333 12.5 9.33333H5.83333C5.47971 9.33333 5.14057 9.4738 4.89052 9.72385C4.64048 9.9739 4.5 10.313 4.5 10.6667V26.6667C4.5 27.0203 4.64048 27.3594 4.89052 27.6095C5.14057 27.8595 5.47971 28 5.83333 28H21.8333C22.187 28 22.5261 27.8595 22.7761 27.6095C23.0262 27.3594 23.1667 27.0203 23.1667 26.6667V20C23.1667 19.6464 23.0262 19.3072 22.7761 19.0572C22.5261 18.8071 22.187 18.6667 21.8333 18.6667H4.5",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedSpace);
export default __webpack_public_path__ + "static/media/shared-space.32936f1b30cd0e1b1efd73457a7e8a6a.svg";
export { ForwardRef as ReactComponent };